<div class="mb-3">
  <app-field-title [titleInfo]="inputContent" [formControlObj]="formControlObj">
    <ng-select [formControl]="formControlObj" [items]="optionsObs | async" bindLabel="value" bindValue="key"
      [placeholder]="isOptionLoading ? 'Loading..' :'Your answer'" [multiple]="true"></ng-select>
  </app-field-title>
</div>